<template>

    <section id="faq" class="faq">

      <div class="container">

        <div class="section-title mb-3" data-aos="fade-up">
          <div class="row">
            <h1 data-aos="fade-up">Perguntas frequentes</h1>
            <h5 class="mb-4" data-aos="fade-up" data-aos-delay="400">Surgiu alguma dúvida?</h5>
          </div>
        </div>

        <div class="faq-list">
          <ul>
            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-1" class="collapsed">
                Qual tipo de nota fiscal posso emitir pelo Sigame?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-1" class="collapse" data-bs-parent=".faq-list">
                <p>
                  <i class="bi bi-check-circle-fill" style="color: #009587;"></i>
                  O Sigame emite notas fiscais de serviço eletrônicas (NFS-e).
                </p>
                <!--<p>
                  <i class="bi bi-exclamation-circle-fill"></i>
                  A plataforma ainda não está disponível para quem precisa emitir notas fiscais para venda de produtos físicos (NF-e).
                </p>-->
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-2" class="collapsed">
                Qual tipo de certificado digital preciso?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-2" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Somente o certificado digital A1 (eCNPJ A1) suporta a automação que o Sigame oferece.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-3" class="collapsed">
                Como faço para emitir notas fiscais de serviço eletrônicas?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-3" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Primeiro, é preciso ter um registro do seu negócio como pessoa jurídica na plataforma Sigame, obter autorização junto à prefeitura de sua cidade para emitir notas fiscais em seu CNPJ e obter Login e Senha de acesso ao sistema de ISS da prefeitura.
                </p>
                <p>
                  Após está primeira fase, basta configurar os dados fiscais na opção “Empresa” e iniciar a emissão dos documentos fiscais.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-4" class="collapsed">
                Posso emitir notas fiscais pela API de integração?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-4" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Sim, após você obter as autorizações junto à prefeitura, conecte a emissão de NFS-e com sua plataforma de pagamento através da opção "Integração" e inicie os testes pelo ambiente de "homologação", se tudo for validado agora é só configurar sua empresa para o ambiente de "Produção" e pronto.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-5" class="collapsed">
                Em quanto tempo vou conseguir emitir as minhas notas fiscais?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-5" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Pedimos um prazo para configuração de até 48 horas para cidades atendidas já homologadas. Esse prazo garante que a configuração seja feita da melhor forma possível.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-6" class="collapsed">
                Posso emitir uma nota manual avulsa?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-6" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Sim, você pode emitir a NFS-e de forma manual sem nenhum processo de integração com plataformas de pagamento ou ERPs lançando cada nota na plataforma e enviando para a fila de processamento através da "Data de Competência" desejada.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-7" class="collapsed">
                Como funciona a garantia de satisfação?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-7" class="collapse" data-bs-parent=".faq-list">
                <p class="mb-2">
                </p>
                <div class="image d-flex justify-content-start mb-3" data-aos="fade-right" data-aos-delay="150">
                  <a href="/">
                    <img src="../assets/img/selo-de-garantia-sigame.png" alt="" class="img-fluid" style="width: 180px;">
                  </a>
                </div>
                <p class="mb-3">
                  Se por qualquer motivo que seja, dentro dos primeiros 30 dias você acreditar que o Sigame não é a melhor solução para seu negócio, basta entrar em contato solicitando o reembolso que devolveremos 100% do seu investimento e cancelaremos seu registro de licença de uso na plataforma.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">

              <a data-bs-toggle="collapse" data-bs-target="#faq-list-8" class="collapsed">
                O que acontece se eu exceder o limite do meu plano?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>

              <div id="faq-list-8" class="collapse" data-bs-parent=".faq-list">
                <p class="mb-2">
                  Conforme as demandas do negócio forem crescendo, é importante que efetue upgrade do seu plano para um que melhor comporte o seu crescimento de vendas.
                </p>
                <!--
                <p>
                  <i class="bi bi-exclamation-circle-fill"></i>
                  Observação:
                  <ul class="subitem">
                    <li>
                      Lembrando que a fatura refere-se aos excedentes do mês anterior.
                    </li>
                    <li>
                      Conforme as demandas do negócio forem crescendo, é importante que efetue upgrade do seu plano antes da geração dos excedentes, pois sua mudança de plano só valerá para as notas emitidas após a identificação do pagamento do novo plano, logo, as notas excedentes serão devidas.
                    </li>
                  </ul>
                </p>
                -->
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-9" class="collapsed">
                Upgrade de plano de assinatura?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-9" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Quando necessário, você poderá trocar o seu plano de assinatura contratado para ter acesso a uma franquia de notas maior para atender suas novas demandas.
                </p>
                <p class="mb-2">
                  Caso seu negócio ainda precisar de mais notas fiscais e não for um dos planos principais da plataforma, fale com a gente e solicite um plano personalizado para você.
                </p>
                <p>
                  <i class="bi bi-exclamation-circle-fill"></i>
                  Observação:
                  <ul class="subitem">
                    <!--
                    <li>
                      O upgrade de plano será considerado uma nova assinatura, na qual será cobrada a diferença entre o seu plano atual e o novo plano assinado. Nas faturas seguintes, será cobrado o valor normal do plano assinado mais os excedentes do plano anterior caso ele tenha sido ultrapassado naquele período.
                    </li>
                    -->
                    <li>
                      Para o cliente fazer upgrade ou donwgrade ele precisa necessáriamente adquirir o próximo plano, e dentro do ADM da plataforma Greenn acessar o contrato antigo dele e encerrar, ou seja, não migra e nem encerra de forma automática, essa gestão de contratos é manual.
                    </li>
                  </ul>
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">

              <a data-bs-toggle="collapse" data-bs-target="#faq-list-10" class="collapsed">
                Downgrade de plano de assinatura?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>

              <div id="faq-list-10" class="collapse" data-bs-parent=".faq-list">
                <p class="mb-2">
                  O downgrade de um plano de assinatura pode ser realizado a qualquer momento e sem custos adicionais, bastando a empresa estar adimplente com suas obrigações é só solicitar o downgrade através de um de nossos canais de atendimento.
                </p>
                <p>
                  <i class="bi bi-exclamation-circle-fill"></i>
                  Observação:
                  <ul class="subitem">
                    <li>
                      O Sigame não realiza devoluções de valores para downgrades realizados antes do final do ciclo vigente da assinatura atual, exceto em situações que forem previamente acordadas para "Planos Personalizados" e a abrangência das cláusulas do contrato contiverem tal acordo.
                    </li>
                  </ul>
                </p>

              </div>
            </li>

          </ul>
        </div>

      </div>

  </section>

</template>

<script>
export default {
  name: 'FaqComp'
}
</script>

<style scoped lang="scss">
.faq {
  background-color: $faq-bg-color;
  padding: 20px 0;
  overflow: hidden;
  padding-bottom: 60px;
}

.faq .faq-list {
  padding: 0 100px;
}

.faq .faq-list ul {
  padding: 0;
  list-style: none;
}

.faq .faq-list li+li {
  margin-top: 15px;
}

.faq .faq-list li {
  padding: 20px;
  background: $bg-base;
  border-radius: 4px;
  position: relative;
}

.faq .faq-list a {
  display: block;
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: $color-base;
  outline: none;
  cursor: pointer;
  text-decoration: none;
}

.faq .faq-list .icon-help {
  font-size: 24px;
  position: absolute;
  right: 0;
  left: 20px;
  color: $a-color;
}

.faq .faq-list .subitem li {
  padding: 15px 0px 0px 0px;
  margin-top: 0px;
  margin-left: 40px;
  list-style: outside;
}

.faq .faq-list .icon-show,
.faq .faq-list .icon-close {
  font-size: 2rem;
  color: $a-color;
  position: absolute;
  right: 0;
  top: 0;
}

.faq .faq-list p {
  margin-bottom: 0;
  padding: 15px 0 0 0;
}

.faq .faq-list .icon-show {
  display: none;
}

.faq .faq-list a.collapsed {
  color: $color-base;
}

.faq .faq-list a.collapsed:hover {
  color: $a-color;
}

.faq .faq-list a.collapsed .icon-show {
  display: inline-block;
}

.faq .faq-list a.collapsed .icon-close {
  display: none;
}

@media (max-width: 1200px) {
  .faq .faq-list {
    padding: 0;
  }
  .faq .faq-list a {
    margin-right: 20px;
  }
  .faq .faq-list .icon-show,
  .faq .faq-list .icon-close {
    right: -28px;
  }
}

@media (max-width: 667px) {
  .faq .faq-list {
    padding: 0;
  }
  .faq .faq-list a {
    margin-right: 20px;
  }
  .faq .faq-list .icon-show,
  .faq .faq-list .icon-close {
    right: -28px;
  }
}

</style>
